import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.1 1h13.3c.6 0 1.1.4 1.1 1v3.8L20 1.5v12L15.5 9v3.8c0 .6-.5 1-1 1H1C.5 14 0 13.6 0 13V2c0-.6.5-1 1.1-1zm13 11.3V2.6H1.7v9.7H14z" })
});
export default SvgCamera;
